/* unplugin-vue-components disabled */import script from "./RoleCardCapabilitiesSkills.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleCardCapabilitiesSkills.vue?vue&type=script&setup=true&lang=js"

import "./RoleCardCapabilitiesSkills.vue?vue&type=style&index=0&id=750d64b6&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-750d64b6"]])

export default __exports__